import { render, staticRenderFns } from "./PublicDocuments.vue?vue&type=template&id=e853eea6&"
import script from "./PublicDocuments.vue?vue&type=script&lang=js&"
export * from "./PublicDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports